import {useDispatch, useSelector} from 'react-redux';
import {useHistory, useParams} from 'react-router-dom';
import React, {useEffect, useState} from 'react';
import {hasPermission} from '../../../helpers/functions';
import {PERMISSIONS} from '../../../helpers/constants';
import {useTranslation} from 'react-i18next';
import {mainPath} from '../../../routes/paths';
import CompaniesHero from '../../Components/Companies/CompaniesHero';
import LoadPanel from '../../Components/LoadPanel';
import {getCompanyEmployeeInner, getCompanyEmployeeList} from '../../../redux/actions/employee/employeeActions';
import EmployeesInner from '../../Components/Companies/EmployeesInner';

const CompaniesCustomersSingle = () => {
  const {employeeId} = useParams();
  const dispatch = useDispatch();
  const {clientId} = useParams();
  const [btnLoading, setBtnLoading] = useState(false);
  const history = useHistory();

  const {profileMe} = useSelector((state) => state.profile);

  const {singleCompany} = useSelector((state) => state.company);

  const editPermission = hasPermission(PERMISSIONS.EMPLOYEE_EDIT, profileMe?.permissions ?? []);
  const fireEmployeePermission = hasPermission(PERMISSIONS.EMPLOYEE_FIRE, profileMe?.permissions ?? []);
  const returnEmployeePermission = hasPermission(PERMISSIONS.EMPLOYEE_RETURN, profileMe?.permissions ?? []);
  const {companyEmployeesList, companyEmployeesListLoading, companyEmployeesInner, companyEmployeesInnerLoading} =
    useSelector((state) => state.employee);

  const {t} = useTranslation();

  useEffect(() => {
    if (companyEmployeesListLoading && !companyEmployeesList.length) {
      dispatch(getCompanyEmployeeList(singleCompany.id));
    }
  }, [dispatch, singleCompany.id, companyEmployeesListLoading]);

  useEffect(() => {
    const fetch = async () => {
      await dispatch(getCompanyEmployeeInner(singleCompany.id, employeeId));
    };

    if (Object.keys(singleCompany).length > 0) {
      fetch();
    }
  }, [singleCompany, clientId]);

  const handleAdd = () => {
    history.push(`${mainPath.companiesEmployeesAdd.replace(':id', singleCompany?.id)}`);
  };

  const handleBack = () => {
    history.push(mainPath.companiesEmployees.replace(':id', singleCompany?.id));
  };

  const addPermission = hasPermission(PERMISSIONS.EMPLOYEE_CREATE, profileMe?.permissions ?? []);
  const readPermission = hasPermission(PERMISSIONS.PERMISSION_VIEW, profileMe?.permissions ?? []);
  const viewProjectPermission = hasPermission(PERMISSIONS.MEMBER_PROJECT_LIST, profileMe?.permissions ?? []);

  return (
    <div className='companies-customers-wrapper'>
      <div className='companies-customers'>
        <div className='companies-name'>{singleCompany?.name ?? ''}</div>

        <CompaniesHero
          heading={`${companyEmployeesList.length} ${t('companiesEmployees.headingHero')}`}
          subHeading={t('companiesEmployees.subHeadingHero')}
          selectedBack={true}
          handleList={handleBack}
          selectedList={true}
          handleAdd={handleAdd}
          disabledActionAdd={!addPermission}
        />
        {companyEmployeesInnerLoading || companyEmployeesListLoading ? (
          <LoadPanel noBg={true} circleSize={40} staticPos={true} />
        ) : (
          <>
            <EmployeesInner
              companyId={singleCompany.id}
              setBtnLoading={setBtnLoading}
              btnLoading={btnLoading}
              editPermission={editPermission}
              companyEmployeesInner={companyEmployeesInner}
              readPermission={readPermission}
              viewProjectPermission={viewProjectPermission}
              fireEmployeePermission={fireEmployeePermission}
              returnEmployeePermission={returnEmployeePermission}
              removePermission={fireEmployeePermission}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default CompaniesCustomersSingle;
